export default "__VITE_ASSET__3sPsIVl7__"